import { render, staticRenderFns } from "./add.vue?vue&type=template&id=34bf0197"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bf0197')) {
      api.createRecord('34bf0197', component.options)
    } else {
      api.reload('34bf0197', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=34bf0197", function () {
      api.rerender('34bf0197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/add.vue"
export default component.exports